let dummyStore = {
    section1: [
        'Select which text you want to practice!'],
    title: 'Title'
};

export default dummyStore;